<template>
  <v-app id="app">
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-form>
              <v-card class="elevation-12">
                <v-toolbar
                  color="#a82420"
                  dark
                  flat>
                  <v-toolbar-title>Digital Agency</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-text-field
                      v-model.trim="form.login"
                      label="Имя пользователя"
                      name="login"
                      autofocus
                      prepend-icon="mdi-account"
                      :error-messages="verrLogin"
                      type="text"/>

                    <v-text-field
                      v-model.trim="form.password"
                      label="Пароль"
                      name="password"
                      prepend-icon="mdi-lock"
                      :error-messages="verrPassword"
                      type="password"/>
                </v-card-text>
                <v-card-actions class="pt-0">
                  <v-spacer></v-spacer>
                  <v-btn type="submit" color="primary" min-width="100" :loading="loading" @click.prevent="loginAction" class="mr-2">Войти</v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </v-content>

    <Snackbar ref="snackbar"/>
  </v-app>
</template>

<script>
  import Snackbar from '@/components/Snackbar.vue'
  import { validationMixin } from 'vuelidate'
  import { required } from 'vuelidate/lib/validators'
  import api from '@/api'

  export default {
    components: { Snackbar },
    mixins: [ validationMixin ],
    data: () => ({
      loading: false,
      form: { login: '', password: '' }
    }),
    validations: {
      form: {
        login: { required },
        password: { required }
      }
    },
    computed: {
      verrLogin () {
        return !this.$v.form.login.$dirty ? [] :
          !this.$v.form.login.required ? 'Введите имя пользователя' : []
      },
      verrPassword () {
        return !this.$v.form.password.$dirty ? [] :
          !this.$v.form.password.required ? 'Введите пароль' : []
      }
    },
    methods: {
      loginAction () {
        this.$v.$touch()
        if ( this.$v.$error ) return
        this.loading = true
        api.post('account/login', this.form).then(response => {
          this.loading = false
          if ( response.data.result !== 'ok' ) return this.$root.$alert(response.data.data, true)
          localStorage.setItem('token', response.data.data.token)
          self.location.reload()
        }).catch(error => {
          this.loading = false
          return this.$root.$alert(error, true)
        })
      }
    },
    mounted () {
      this.$root.$alert = this.$refs.snackbar.show
    }
  }
</script>
